import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import { mergeAndStringifyEntityObjects } from '@functions/entity'

import defaultState, { requiredFields } from '@models/publicationSpecialDeadline'

import * as publicationSpecialDeadlineActions from '@redux/modules/publicationSpecialDeadline'

const createPublicationSpecialDeadline = (params) => {
  const { specialDeadlineParams, dispatch, requestOptions } = params
  const { createPublicationSpecialDeadline: createFn } = publicationSpecialDeadlineActions

  const stringifyObjectKeys = ['options']
  const updatedParams = mergeAndStringifyEntityObjects({}, specialDeadlineParams, stringifyObjectKeys)

  return dispatch(createFn(updatedParams, requestOptions))
}

const deletePublicationSpecialDeadline = (params) => {
  const { publicationSpecialDeadline, dispatch } = params
  const { deletePublicationSpecialDeadline: deleteFn } = publicationSpecialDeadlineActions

  return dispatch(deleteFn(publicationSpecialDeadline))
}

const addPublicationSpecialDeadline = params => new Promise((resolve, reject) => {
  const { publicationSpecialDeadline, showCreatePublicationSpecialDeadlineModal } = params

  if (showCreatePublicationSpecialDeadlineModal){
    const payload = {
      publicationSpecialDeadline,
    }

    showCreatePublicationSpecialDeadlineModal(payload)

    resolve({ success: true, result: payload })
  }

  reject(new Error('showCreatePublicationSpecialDeadlineModal not defined in PageContext callbacks'))
})

export function usePublicationSpecialDeadlineForm(publicationSpecialDeadline = {}, options = {}){
  const { validateOn } = options

  const publicationSpecialDeadlineForm = useForm(
    defaultState,
    { entity: publicationSpecialDeadline, requiredFields, validateOn },
    [publicationSpecialDeadline.id, publicationSpecialDeadline.cache_key],
  )

  return {
    ...publicationSpecialDeadlineForm,
  }
}

function usePublicationSpecialDeadline(initEntity = {}){
  const { entity: publicationSpecialDeadline } = useLatestEntity(initEntity, 'publicationSpecialDeadlines')
  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreatePublicationSpecialDeadlineModal } = callbacks || {}

  const { creating } = useSelector(reduxState => reduxState.publicationSpecialDeadlines)

  return {
    callbacks: {
      addPublicationSpecialDeadline: () => addPublicationSpecialDeadline({
        publicationSpecialDeadline,
        showCreatePublicationSpecialDeadlineModal,
      }),
      createPublicationSpecialDeadline: (specialDeadlineParams, requestOptions) => (
        createPublicationSpecialDeadline({ specialDeadlineParams, dispatch, requestOptions })
      ),
      deletePublicationSpecialDeadline: () => (
        deletePublicationSpecialDeadline({ publicationSpecialDeadline, dispatch })
      ),
    },
    creating,
    publicationSpecialDeadline,
  }
}

export default usePublicationSpecialDeadline
